import {ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from "@angular/core";
import {NavigationEnd, Router} from "@angular/router";
import {filter, Observable, Subject, takeUntil} from "rxjs";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {environment} from "../environments/environment";
import {SharedService} from "./core/services/shared.service";
import {ScrollDispatcher} from "@angular/cdk/overlay";
import {Title} from "@angular/platform-browser";
import {AnalyticsService} from "./core/services/analytics.service";
import {SeoService} from "./core/services/seo.service";


@Component({
  selector: "sw-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  private onDestroy: Subject<void> = new Subject<void>();
  @ViewChild("swApp") swApp?: ElementRef;
  showModal$: Observable<boolean>;
  isScrolled: boolean = false;

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) private platform: Object,
    private sharedService: SharedService,
    private cdRef: ChangeDetectorRef,
    private scrollDispatcher: ScrollDispatcher,
    private analyticsService: AnalyticsService,
    private title: Title,
    private seo: SeoService,
    private router: Router) {
    this.showModal$ = sharedService.showModal$;
    if (isPlatformBrowser(this.platform)) {
      console.log(`${environment.name} release: `, environment.releaseVersion);

      this.scrollDispatcher
        .scrolled()
        .pipe(takeUntil(this.onDestroy))
        .subscribe((scrollable: any) => {
          // Handle scroll event here
          const container = scrollable.getElementRef().nativeElement;
          const scrollTop = container?.scrollTop;
          // Apply your custom logic based on the scroll position
          const newSticky = scrollTop > 0 ? true : false; // Example: set isSticky based on scroll position
          if (newSticky !== this.isScrolled) {
            this.isScrolled = newSticky;
            this.cdRef.detectChanges();
          }

          const isScrollNearBottom =
            container.scrollHeight - container.clientHeight <= container.scrollTop + 1;

          if (isPlatformBrowser(this.platform) && isScrollNearBottom) {
            this.sharedService.fireScrollEvent();
          }
        });
    }
  }

  ngOnInit(): void {
    this.router.events.pipe(
      takeUntil(this.onDestroy),
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    )
      .subscribe({
        next: event => {
          if (isPlatformBrowser(this.platform)) {
            if (event?.urlAfterRedirects) {
              this.analyticsService.trackEvent("page_view", {
                page_path: event.urlAfterRedirects,
                page_title: document.title,
                page_location: window.location.href
              });
              this.analyticsService.pushTag({
                event: "page_view",
                page_path: event.urlAfterRedirects,
                page_title: document.title,
                page_location: window.location.href
                // You can add more parameters here if you need them
              });
            }
            if (this.swApp) {
              this.swApp.nativeElement.scrollTop = 0;
            }
          }
        }
      });

    this.title.setTitle("Schoonmaakwoede, dé landelijke schoonmaak specialist voor uw huis");
    this.setDefaultSeo();
  }


  private setDefaultSeo(): void {
    this.seo.apply({
      title: "Schoonmaakwoede, dé landelijke schoonmaak specialist voor uw huis",
      description: "Uw huis schoon laten maken door professionele vakmensen? Bestel direct online de schoonmaak voor uw huis.",
      canonicalPath: "/",
      og: {type: "website", imageUrl: "https://schoonmaakwoede.nl/assets/logo.png"}
    });
  }


  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
